import { FormCloudEnvironment, GlobalResponse } from '~/models/Commons ';
import { api } from '../api';
import { CLOULD_ENVIRONMENTS} from '../endpoints';
import { SET_CLOUDENVIRONMENT } from '~/store/feature/CloudEnvironment';
import { getHeaders } from '../generics/Header';

const extendedApiSlice = api.injectEndpoints({
  endpoints: builder => ({
    getCloudEnvironments: builder.query<
      GlobalResponse<any[]>,
      { page: number; size: number; active: boolean }
    >({
      query: ({ page, size, active }) => ({
        url: `${CLOULD_ENVIRONMENTS}?page=${page}&size=${size}&active=${active}`,
        method: 'GET',
        credentials: 'include',
        headers: getHeaders()
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(SET_CLOUDENVIRONMENT(data.payload));
        } catch (error) {
          console.error('Error fetching scripts:', error);
        }
      },
    }),
       selectGCloudEnvironments: builder.query<
      GlobalResponse<any[]>,
      { page: number; size: number }
    >({
      query: ({ page, size}) => ({
        url: `${CLOULD_ENVIRONMENTS}?page=${page}&size=${size}`,
        method: 'GET',
        credentials: 'include',
        headers: getHeaders()
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(SET_CLOUDENVIRONMENT(data.payload));
        } catch (error) {
          console.error('Error fetching scripts:', error);
        }
      },
    }),
    saveCloudEnvironment: builder.mutation<GlobalResponse<FormCloudEnvironment>, FormCloudEnvironment>({
      query: (data) => {
        const token = sessionStorage.getItem('access_token');
        if (!token) {
          throw new Error('No access token found');
        }
    
        return {
          url: CLOULD_ENVIRONMENTS, 
          method: 'POST',
          body: data,
          credentials: 'include',
          headers:getHeaders()
        }
      },
    }),
      updateCloudEnvironment: builder.mutation<GlobalResponse<FormCloudEnvironment>, { id: number; data: FormCloudEnvironment }>(
        {
          query: ({ id, data }) => ({
            url: `${CLOULD_ENVIRONMENTS}/${id}`,
            method: 'PUT',
            body: data,
            formData: true,
            credentials: 'include',
            headers:getHeaders()
          }),
        }
      ),
      
    deleteCloudEnvironments: builder.mutation<GlobalResponse<FormCloudEnvironment>, number>({
      query: cloudEnvironmentId => ({
        url: `${CLOULD_ENVIRONMENTS}/${cloudEnvironmentId}`,
        method: 'DELETE',
        credentials: 'include',
        headers: getHeaders()
      }),
    }),
  }),
});

export const {
  useSaveCloudEnvironmentMutation,
  useUpdateCloudEnvironmentMutation,
  useGetCloudEnvironmentsQuery,
  useSelectGCloudEnvironmentsQuery,
  useLazyGetCloudEnvironmentsQuery,
  useDeleteCloudEnvironmentsMutation,
} = extendedApiSlice;